import axios from "axios";
import loginService from "./services/loginService";

const axiosInstance = axios.create({
  baseURL: process.env.REACT_APP_API_BASE_URL,
  timeout: 300000,
  withCredentials: true,
});

axiosInstance.interceptors.request.use(
  (config) => {
    // const token = localStorage.getItem("token");
    // if (token) {
    //   config.headers["Authorization"] = `Bearer ${token}`;
    // }

    config.metadata = { startTime: new Date() };

    return config;
  },
  (error) => Promise.reject(error),
);

axiosInstance.interceptors.response.use(
  (response) => response,
  async (error) => {
    if (error.response?.data?.code === 401) {
      try {
        await loginService.silentLogout(); // clears httpOnly cookie
      } catch (e) {
        console.log("Silent logout failed");
      }

      localStorage.clear();
      window.location.href = "/login";
    }

    return Promise.reject(error);
  },
);

export default axiosInstance;
